import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=7b4e5d82&"
import script from "./Policy.vue?vue&type=script&lang=ts&"
export * from "./Policy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports